import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Spin, DatePicker, } from "antd";
import moment from "moment";
import { intervalData } from "../data";
import '../index.scss'

import Revenue from "./revenue";
import Purchase from "./purchase";
import Room from "./room";
import Food from "./food";
import Human from "./human";
import Energy from "./energy";
import FoodBeverage from "./foodBeverage";
import Other from "./other";
import RestaurantIncome from "./RestaurantIncome";
import RestaurantCost from "./RestaurantCost";

import { runInAction } from 'mobx';
import getJson from '../../../../method/getJson';
import ComponentData from "../MTD";
import Table1_2_1 from './1.2.1'


const { MonthPicker } = DatePicker;

@inject('store')
@observer
class index extends ComponentData {

    async componentDidMount() {
        this.getData(this.props.store.analysis.date).then(x => {
            const timer = setTimeout(() => {
                this.props.store.analysis.getData();
                clearTimeout(timer);
            }, 500);
        });
        window.addEventListener('resize', () => {
            if (window.location.hash === '#/table/analysisChart') {
                this.props.store.analysis.onResize();
            }
        });
    }

    render() {
        const { loading, date, getData, data } = this.props.store.analysis;
        const style = {
            marginLeft: 10,
            color: "#195A95"
        };
        return (
            <Spin tip="加载中..." spinning={loading}>
                <Table1_2_1 />
                <div className='analysisChart' id='analysisChart'>
                    <Row  >
                        <Row className="table-title">1.2.2 Monthly Visual Diagram 月度可视化图表 </Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={async (date, str) => {
                                    runInAction(() => {
                                        this.props.store.analysis.date = str;
                                        this.props.store.analysis.loading = true;
                                    });

                                    this.getData(str).then(x => {
                                        const timer = setTimeout(() => {
                                            getData();
                                            clearTimeout(timer);
                                        }, 700);
                                    });
                                }}
                            />
                            <span style={style}>区域 : {getJson(['hotel', 'area'], data, "")} </span>
                            <span style={style}>收入区间 : {intervalData[getJson(['hotel', 'income_interval'], data, "")]} </span>
                        </Row>
                    </Row>

                    <div className="list">
                        <Revenue />
                        <Purchase />
                        <Room />
                        <Food />
                        <Human />
                        <FoodBeverage />
                        <Energy />
                        <Other />
                        <RestaurantIncome />
                        <RestaurantCost />
                    </div>
                </div>
            </Spin>

        )
    }
}

export default index


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/analysisChart/index.js